'use client'
import { AIRPORT_DB } from './AirportCombobox'

export default function DealsActiveFilters({
  dealTypeTab, setDealTypeTab,
  weekendOnly, setWeekendOnly,
  stopsFilter, setStopsFilter,
  destFilter, updateDestFilter,
  filterAirports, setFilterAirports,
  airlineFilter, setAirlineFilter,
  searchText, setSearchText,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  maxPriceFilter, setMaxPriceFilter,
}) {
  const hasActive = dealTypeTab !== 'all' || weekendOnly || stopsFilter !== 'all' || destFilter.length > 0 || filterAirports.length > 0 || airlineFilter.length > 0 || searchText || dateFrom || dateTo || maxPriceFilter
  if (!hasActive) return null

  const TAB_LABELS = { red: '⚡ Error Fares', orange: '🔥 Exceptional', green: '💚 Good Price', award: '✈️ Award' }
  const TAB_COLORS = { red: 'bg-red-600', orange: 'bg-orange-500', green: 'bg-green-600', award: 'bg-gray-900' }

  return (
    <div className="mb-4 flex flex-wrap items-center gap-1.5">
      <span className="text-xs font-medium text-gray-400 shrink-0">Active:</span>
      {dealTypeTab !== 'all' && (
        <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium text-white ${TAB_COLORS[dealTypeTab] ?? 'bg-gray-900'}`}>
          {TAB_LABELS[dealTypeTab] ?? dealTypeTab}
          <button onClick={() => setDealTypeTab('all')} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      {weekendOnly && (
        <span className="inline-flex items-center gap-1 rounded-full bg-violet-600 px-2.5 py-0.5 text-xs font-medium text-white">
          🏖 Weekend
          <button onClick={() => setWeekendOnly(false)} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      {stopsFilter !== 'all' && (
        <span className="inline-flex items-center gap-1 rounded-full bg-blue-600 px-2.5 py-0.5 text-xs font-medium text-white">
          {stopsFilter === 'direct' ? '✈ Direct' : '1 stop'}
          <button onClick={() => { setStopsFilter('all'); localStorage.setItem('ff_stops_filter', 'all') }} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      {destFilter.map((d) => (
        <span key={d} className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
          → {d}
          <button onClick={() => updateDestFilter(destFilter.filter((x) => x !== d))} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      ))}
      {filterAirports.map((ap) => (
        <span key={ap} title={`${AIRPORT_DB[ap]?.city ?? ap} (${ap})`} className="inline-flex items-center gap-1 rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-800">
          {AIRPORT_DB[ap]?.flag ?? '✈️'} {AIRPORT_DB[ap]?.city ?? ap}
          <button onClick={() => setFilterAirports((prev) => prev.filter((a) => a !== ap))} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      ))}
      {airlineFilter.map((al) => (
        <span key={al} className="inline-flex items-center gap-1 rounded-full bg-rose-100 px-2.5 py-0.5 text-xs font-medium text-rose-800">
          {al}
          <button onClick={() => setAirlineFilter((prev) => prev.filter((a) => a !== al))} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      ))}
      {searchText && (
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">
          &ldquo;{searchText}&rdquo;
          <button onClick={() => setSearchText('')} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      {dateFrom && (
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">
          From {dateFrom}
          <button onClick={() => setDateFrom('')} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      {dateTo && (
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">
          Until {dateTo}
          <button onClick={() => setDateTo('')} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      {maxPriceFilter && (
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">
          Max €{maxPriceFilter}
          <button onClick={() => setMaxPriceFilter('')} className="ml-0.5 opacity-60 hover:opacity-100" aria-label="Remove">✕</button>
        </span>
      )}
      <button
        onClick={() => {
          setDealTypeTab('all')
          setWeekendOnly(false)
          setStopsFilter('all')
          localStorage.setItem('ff_stops_filter', 'all')
          updateDestFilter([])
          setFilterAirports([])
          setAirlineFilter([])
          setSearchText('')
          setDateFrom('')
          setDateTo('')
          setMaxPriceFilter('')
        }}
        className="ml-1 text-xs text-red-500 hover:text-red-700 font-medium"
      >
        Clear all
      </button>
    </div>
  )
}
